/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("WindowCanCloseVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class WindowCanCloseVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.WindowCanCloseVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.WindowCanCloseVMBehavior.prototype */ {
      /** @type {string} */
      __name: "WindowCanCloseVMBehavior",

      watchedAttributes: {
        parent: ["active"],
        anchor: ["active"]
      },
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const anchorNode = controller.getAnchorNode(),
          windowNode = anchorNode && anchorNode.getAncestor("Window"),
          windowController = windowNode && windowNode.getController(),
          windowWidget = windowController && windowController.getWidget();
        let activeValue = true;
        const windowOptionClose = windowNode.getStyleAttribute("windowOptionClose");
        if (windowWidget && windowWidget.setClosable) {
          activeValue = anchorNode.attribute("active");
          windowWidget.setClosable(activeValue, windowOptionClose === null);
        }
        // Close action is displayed in the action panel only when:
        //   - defaultView = "yes" (programmer asked to show it in the panel),
        //   - the action is NOT pushed to the chromebar (actionPanelPosition <> "chrome"),
        //   - the close button is not handled by a native client (GDC/GMA).
        // When the chromebar is visible AND defaultView=yes, the action is duplicated:
        // it appears in the chromebar (GBC singleton item) AND in the action panel.
        const isInChromeBar = controller.isInChromeBar();
        if (!isInChromeBar && window.gbcWrapper.isCloseButtonVisibleInDefaultView(anchorNode.attribute("defaultView"))) {
          const hidden = anchorNode.isAttributePresent("hidden") ? anchorNode.attribute("hidden") : false;
          anchorNode
            .getController()
            .getWidget()
            ?.setHidden(hidden || !activeValue);
        } else {
          anchorNode.getController().getWidget()?.setHidden(true);
        }
      },

      /**
       * @inheritDoc
       */
      _detach: function (controller) {
        const anchorNode = controller.getAnchorNode(),
          windowNode = anchorNode && anchorNode.getAncestor("Window"),
          windowController = windowNode && windowNode.getController(),
          windowWidget = windowController && windowController.getWidget();
        if (windowWidget && windowWidget.setClosable) {
          windowWidget.setClosable(false);
        }
      }
    };
  });
});
